import { TemplateItem } from '@anm/api/modules/templates';
import useResize from '@anm/hooks/useResize';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useEffect, useState } from 'react';

import { SliderArrowWrapper } from './Wrapper';
import { calcSize, DEFAULT_SIZE } from './helpers';
import { ArrowProps } from './types';

const SliderArrow = (props: ArrowProps) => (
  <SliderArrowWrapper
    {...props}
    className="slider-custom-arrow"
    aria-label={`slider ${props.direction} button`}
  />
);

export const useSliderArrows = (list: TemplateItem[]) => {
  const [isLeftArrowVisible, showLeftArrow, hideLeftArrow] = useSwitchState();
  const [isRightArrowVisible, showRightArrow, hideRightArrow] = useSwitchState(
    true
  );

  const handleBeforeChange = (oldIndex: number, newIndex: number) => {
    const sliderOffset = 1;
    const steps = newIndex - oldIndex;

    const isLastGroup = newIndex + steps + sliderOffset >= list.length;

    newIndex ? showLeftArrow() : hideLeftArrow();
    isLastGroup ? hideRightArrow() : showRightArrow();
  };

  const arrowSettings = {
    prevArrow: <SliderArrow direction="left" hideLeft={!isLeftArrowVisible} />,
    nextArrow: (
      <SliderArrow direction="right" hideRight={!isRightArrowVisible} />
    ),
    beforeChange: handleBeforeChange,
    onInit: () => {
      showRightArrow();
      hideLeftArrow();
    }
  };

  return arrowSettings;
};

export const useCalcItemWidth = () => {
  const [width, setWidth] = useState(DEFAULT_SIZE);

  useResize(() => setWidth(calcSize()));

  useEffect(() => {
    setWidth(calcSize());
  }, []);

  return width;
};
